/* eslint-disable max-len */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
// ==============================================
// ==================Import======================
// ==============================================

// ==================React Hooks===================
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// ==================Actions===================
import { fetchPersonalizedPageHtml } from '../../actions/personalized';

// ==================Style&IMG===================
import './style.scss';

// ==================Components===================
import Title from './Title';
import Heading from './Heading';
import Paragraph from './Paragraph';
import Spinner2 from '../Spinner2';
import Table from './Table';
import Text from './Text';
import Image from './Image';
import Email from './Email';
import Url from './Url';
import Date from './Date';
import DocumentChooser from './DocumentChooser';
import Video from './Video';
import Group from './Group';
import { globalConfig } from '../../configuration/config';

function Personalized() {
// ==================Hooks===================
  const dispatch = useDispatch();
  const allPages = useSelector((state) => state.site.allPages);
  const htmlDataToDisplay = useSelector((state) => state.personalized.personalizedPageData);
  const loadingPersonalized = useSelector((state) => state.personalized.loadingPersonalized);
  const loadingHeader = useSelector((state) => state.header.loadingHeader);
  const loadingFooter = useSelector((state) => state.footer.loadingFooter);
  const slug = useParams();

  // =================Lifecycle================
  useEffect(() => {
    if (window.location.hash.includes('404') === false) {
      if (document.getElementsByClassName('app-404').length !== 0) {
        window.location.reload();
      }
    }
  }, []);
  useEffect(
    () => {
      if (allPages.length > 0) {
        const pagesToDisplayToFetch = allPages.find(
          (el) => el.meta.slug === slug.slug,
        );
        if (pagesToDisplayToFetch !== undefined) {
          dispatch(fetchPersonalizedPageHtml(pagesToDisplayToFetch.id, globalConfig.config.REACT_APP_BACKEND_API));
        }
        else {
          window.location.href = `${window.origin}/#/404`;
        }
      }
    },
    [allPages],
  );

  useEffect(() => {
    if (allPages.length > 0) {
      const pagesToDisplayToFetch = allPages.find(
        (el) => el.meta.slug === slug.slug,
      );
      if (pagesToDisplayToFetch !== undefined) {
        dispatch(fetchPersonalizedPageHtml(pagesToDisplayToFetch.id, globalConfig.config.REACT_APP_BACKEND_API));
      }
      else {
        window.location.href = `${window.origin}/#/404`;
      }
    }
  }, []);
  return (
    <div className="personalizedPage">
      {(loadingPersonalized || loadingHeader || loadingFooter) && <Spinner2 />}
      {(
        htmlDataToDisplay.title !== undefined
        && !loadingPersonalized && !loadingHeader && !loadingFooter
      ) && <Title title={htmlDataToDisplay.title} />}
      {(
        Object.keys(htmlDataToDisplay).length !== 0
        && !loadingPersonalized && !loadingHeader && !loadingFooter
      && htmlDataToDisplay.body !== undefined) && htmlDataToDisplay.body.map((el) => {
        const tab = [];
        if (el.type === 'heading') {
          tab.push(<Heading key={el.id} value={el.value} />);
        }
        else if (el.type === 'paragraph') {
          tab.push(<Paragraph key={el.id} value={el.value} />);
        }
        else if (el.type === 'table') {
          tab.push(<Table key={el.id} value={el.value} />);
        }
        else if (el.type === 'Text') {
          tab.push(<Text key={el.id} value={el.value} />);
        }
        else if (el.type === 'image') {
          tab.push(<Image key={el.id} value={el.value} />);
        }
        else if (el.type === 'CharBlock') {
          tab.push(<Text key={el.id} value={el.value} />);
        }
        else if (el.type === 'Email') {
          tab.push(<Email key={el.id} value={el.value} />);
        }
        else if (el.type === 'URL') {
          tab.push(<Url key={el.id} value={el.value} />);
        }
        else if (el.type === 'Date') {
          tab.push(<Date key={el.id} value={el.value} />);
        }
        else if (el.type === 'DocumentChooser') {
          tab.push(<DocumentChooser key={el.id} value={el.value} />);
        }
        else if (el.type === 'EmbedBlock') {
          tab.push(<Video key={el.id} value={el.value} />);
        }
        return tab;
      })}
      {(
        Object.keys(htmlDataToDisplay).length !== 0
        && !loadingPersonalized && !loadingHeader && !loadingFooter
      && htmlDataToDisplay.block_table !== undefined) && htmlDataToDisplay.block_table.map((el) => {
        const tab = [];
        if (el.type === 'group') {
          tab.push(<Group key={el.id} value={el} />);
        }
        return tab;
      })}
    </div>
  );
}

export default Personalized;
